export interface IFacebookPage {
  id: string;
  name: string;
  url: string;
}

export interface IInstagramAccount {
  id: string;
  username: string;
  url: string;
}

export interface IMetaConnectionData {
  businessName: string;
  username: string;
  connectedOn: Date;
  facebookPages: IFacebookPage[];
  instagramAccounts: IInstagramAccount[];
}

const MOCK_CONNECTION_DATA: IMetaConnectionData = {
  businessName: 'Acme Marketing LLC',
  username: 'abhay.khurana',
  connectedOn: new Date('2026-01-13T18:20:00'),
  facebookPages: [
    { id: '1', name: 'Acme Company', url: 'https://facebook.com/acmecompany' },
    { id: '2', name: 'Acme Products', url: 'https://facebook.com/acmeproducts' },
    { id: '3', name: 'Acme Support', url: 'https://facebook.com/acmesupport' },
  ],
  instagramAccounts: [
    { id: '1', username: '@acmecompany', url: 'https://instagram.com/acmecompany' },
    { id: '2', username: '@acmeproducts', url: 'https://instagram.com/acmeproducts' },
  ],
};

export function useMetaConnectionData(): IMetaConnectionData {
  return MOCK_CONNECTION_DATA;
}
